
export class LastMeasureProductionEvent {
  constructor(
    public productionEventHash?: string,
    public productionEventEndTime?: number,
    public programHash?: string,
    public programReference?: string,
    public toolName?: string,
    public toolHolderName?: string,
    public pocket?: number,
  ) { }

  clone() {
    return new LastMeasureProductionEvent (
      this.productionEventHash,
      this.productionEventEndTime,
      this.programHash,
      this.programReference,
      this.toolName,
      this.toolHolderName,
      this.pocket
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/last-measure-production-event.ts